module.exports = __webpack_public_path__ + "static/media/tour-3.2a41c6da.png";